/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addFacilityZoneType } from '../fn/facility-zone-type/add-facility-zone-type';
import { AddFacilityZoneType$Params } from '../fn/facility-zone-type/add-facility-zone-type';
import { deleteFacilityZoneType } from '../fn/facility-zone-type/delete-facility-zone-type';
import { DeleteFacilityZoneType$Params } from '../fn/facility-zone-type/delete-facility-zone-type';
import { FacilityZoneType } from '../models/facility-zone-type';
import { getFacilityZoneTypes } from '../fn/facility-zone-type/get-facility-zone-types';
import { GetFacilityZoneTypes$Params } from '../fn/facility-zone-type/get-facility-zone-types';
import { updateFacilityZoneType } from '../fn/facility-zone-type/update-facility-zone-type';
import { UpdateFacilityZoneType$Params } from '../fn/facility-zone-type/update-facility-zone-type';

@Injectable({ providedIn: 'root' })
export class FacilityZoneTypeService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getFacilityZoneTypes()` */
  static readonly GetFacilityZoneTypesPath = '/api/facilityzonetype';

  /**
   * Get Facility Zone Types.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFacilityZoneTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityZoneTypes$Response(params?: GetFacilityZoneTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FacilityZoneType>>> {
    return getFacilityZoneTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Facility Zone Types.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFacilityZoneTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityZoneTypes(params?: GetFacilityZoneTypes$Params, context?: HttpContext): Observable<Array<FacilityZoneType>> {
    return this.getFacilityZoneTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FacilityZoneType>>): Array<FacilityZoneType> => r.body)
    );
  }

  /** Path part for operation `addFacilityZoneType()` */
  static readonly AddFacilityZoneTypePath = '/api/facilityzonetype';

  /**
   * Add Facility Zone Type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addFacilityZoneType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addFacilityZoneType$Response(params: AddFacilityZoneType$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityZoneType>> {
    return addFacilityZoneType(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Facility Zone Type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addFacilityZoneType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addFacilityZoneType(params: AddFacilityZoneType$Params, context?: HttpContext): Observable<FacilityZoneType> {
    return this.addFacilityZoneType$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityZoneType>): FacilityZoneType => r.body)
    );
  }

  /** Path part for operation `updateFacilityZoneType()` */
  static readonly UpdateFacilityZoneTypePath = '/api/facilityzonetype/{facilityZoneTypeId}';

  /**
   * Update Facility Zone Type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFacilityZoneType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFacilityZoneType$Response(params: UpdateFacilityZoneType$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityZoneType>> {
    return updateFacilityZoneType(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Facility Zone Type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFacilityZoneType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFacilityZoneType(params: UpdateFacilityZoneType$Params, context?: HttpContext): Observable<FacilityZoneType> {
    return this.updateFacilityZoneType$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityZoneType>): FacilityZoneType => r.body)
    );
  }

  /** Path part for operation `deleteFacilityZoneType()` */
  static readonly DeleteFacilityZoneTypePath = '/api/facilityzonetype/{facilityZoneTypeId}';

  /**
   * Delete Facility Zone Type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFacilityZoneType()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFacilityZoneType$Response(params: DeleteFacilityZoneType$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityZoneType>> {
    return deleteFacilityZoneType(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Facility Zone Type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFacilityZoneType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFacilityZoneType(params: DeleteFacilityZoneType$Params, context?: HttpContext): Observable<FacilityZoneType> {
    return this.deleteFacilityZoneType$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityZoneType>): FacilityZoneType => r.body)
    );
  }

}
